// extracted by mini-css-extract-plugin
module.exports = {"section":"AppUpSell-module--section--1JFn2","img":"AppUpSell-module--img--fVmuY"};